/*
  🌿 Karma — Stories (bulles rondes + visionneuse plein écran)

  Pourquoi cette réécriture (2026-08-17, retour de Gita : « quand je clique dessus ça bugue,
  la parole n'est pas en même temps que la vidéo, et ça rame ») :
  l'ancienne version en HTML manuel affichait les 4 vignettes avec de VRAIES vidéos en
  lecture automatique et en boucle. Quatre vidéos téléchargées en continu pour de simples
  pastilles rondes : le réseau saturait, la lecture décrochait et le son se désynchronisait.

  Ici les vignettes sont des IMAGES et une vidéo n'est téléchargée qu'à l'ouverture de la
  story. La visionneuse offre le son, la barre de progression, la pause et le retour arrière.

  Architecture (revue le 2026-08-17 pour que les bulles puissent vivre DANS la colonne
  produit, à leur place d'origine) : les bulles sont de simples boutons portant un attribut
  data-videos, où qu'elles soient dans la page — section pleine largeur OU bloc de fiche
  produit. La visionneuse, elle, est créée UNE SEULE FOIS et rattachée au <body>.
*/

let visionneuse = null;

function creerVisionneuse() {
  if (visionneuse) return visionneuse;

  const dlg = document.createElement('dialog');
  dlg.className = 'karma-visionneuse';
  dlg.innerHTML = `
    <div class="karma-visionneuse__cadre">
      <button type="button" class="karma-visionneuse__fermer" aria-label="Fermer">&times;</button>
      <div class="karma-visionneuse__barres"></div>
      <p class="karma-visionneuse__titre"></p>
      <button type="button" class="karma-visionneuse__prec" aria-label="Précédente">&lsaquo;</button>
      <video class="karma-visionneuse__player" controls playsinline preload="none"></video>
      <button type="button" class="karma-visionneuse__suiv" aria-label="Suivante">&rsaquo;</button>
    </div>`;
  document.body.appendChild(dlg);

  const v = {
    dlg,
    video: dlg.querySelector('.karma-visionneuse__player'),
    barres: dlg.querySelector('.karma-visionneuse__barres'),
    titre: dlg.querySelector('.karma-visionneuse__titre'),
    prec: dlg.querySelector('.karma-visionneuse__prec'),
    suiv: dlg.querySelector('.karma-visionneuse__suiv'),
    liste: [],
    index: 0,
    nom: ''
  };

  const estOuverte = () => dlg.open || dlg.hasAttribute('open');

  const arreter = () => {
    v.video.pause();
    v.video.removeAttribute('src');
    v.video.load();
  };

  const fermer = () => {
    if (typeof dlg.close === 'function') dlg.close();
    else dlg.removeAttribute('open');
    arreter();
  };

  const aller = (i) => {
    if (i < 0) i = 0;
    if (i >= v.liste.length) return fermer();

    v.index = i;
    const item = v.liste[i];
    v.video.poster = item.poster || '';

    /* Flux adaptatif (2026-08-19) — mesuré, pas supposé.
       Liquid ne donne accès qu'à UNE version mp4 : la plus lourde (jusqu'à 7,2 Mbps).
       Les 480p / 720p que Shopify fabrique pourtant n'existent que dans l'API Admin.
       Le m3u8 est, lui, exposé : l'appareil y choisit son palier (480/720/1080).
       Sur connexion faible il démarre bas — c'est là le gain. En wifi il peut monter
       au 1080p : ce n'est donc pas une compression, c'est une lecture qui s'adapte.
       Safari et iOS le lisent nativement, là où se regardent les stories.
       Ailleurs (Chrome, Firefox), on retombe sur le mp4 : rien ne change. */
    const hlsLisible = item.hls && v.video.canPlayType('application/vnd.apple.mpegurl');
    v.video.src = hlsLisible ? item.hls : item.src;
    v.video.muted = false;
    v.video.load();

    const lancer = () => {
      // Fermée entre-temps ? On ne démarre surtout pas : sinon le son continue en fond
      // alors que la visionneuse est close (bug vu et corrigé le 2026-08-17).
      if (!estOuverte()) return;
      const p = v.video.play();
      if (p && typeof p.catch === 'function') {
        p.catch(() => { v.video.muted = true; v.video.play().catch(() => {}); });
      }
    };
    if (v.video.readyState >= 2) lancer();
    else v.video.addEventListener('canplay', lancer, { once: true });

    v.titre.textContent = v.nom;
    [...v.barres.children].forEach((b, n) => {
      b.classList.toggle('is-vue', n < i);
      b.classList.toggle('is-active', n === i);
    });

    const plusieurs = v.liste.length > 1;
    v.prec.hidden = !plusieurs;
    v.suiv.hidden = !plusieurs;
    v.prec.disabled = i === 0;
  };

  dlg.querySelector('.karma-visionneuse__fermer').addEventListener('click', fermer);
  v.prec.addEventListener('click', () => aller(v.index - 1));
  v.suiv.addEventListener('click', () => aller(v.index + 1));
  v.video.addEventListener('ended', () => aller(v.index + 1));
  dlg.addEventListener('click', (e) => { if (e.target === dlg) fermer(); });
  dlg.addEventListener('close', arreter);
  dlg.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowRight') aller(v.index + 1);
    if (e.key === 'ArrowLeft') aller(v.index - 1);
  });

  v.ouvrir = (bulle) => {
    let liste = [];
    try {
      liste = JSON.parse(bulle.dataset.videos || '[]');
    } catch {
      liste = [];
    }
    if (!liste.length) return;

    v.liste = liste;
    v.nom = bulle.dataset.titre || '';

    // Réglages d'apparence portés par la bulle (ils viennent de l'éditeur de thème).
    if (bulle.dataset.fond) dlg.style.setProperty('--kvi-fond', bulle.dataset.fond);
    if (bulle.dataset.arrondi) dlg.style.setProperty('--kvi-arrondi', bulle.dataset.arrondi + 'px');

    v.barres.innerHTML = '';
    if (liste.length > 1) {
      liste.forEach(() => {
        const b = document.createElement('span');
        b.className = 'karma-visionneuse__barre';
        v.barres.appendChild(b);
      });
    }

    aller(0);
    if (typeof dlg.showModal === 'function') dlg.showModal();
    else dlg.setAttribute('open', '');
  };

  visionneuse = v;
  return v;
}

// Délégation : fonctionne pour les bulles présentes au chargement comme pour celles
// ajoutées ensuite par l'éditeur de thème, sans avoir à réinitialiser quoi que ce soit.
document.addEventListener('click', (e) => {
  const bulle = e.target.closest('.karma-stories__bulle');
  if (!bulle) return;
  e.preventDefault();
  creerVisionneuse().ouvrir(bulle);
});
